import { Divider } from '@src/common/components/Divider';
import { LoadingPage } from '@src/common/components/LoadingPage';
import { PageLayout } from '@src/common/components/Page';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import { AddNote } from '@src/notes/components/AddNoteComponent';
import { NoteContext } from '@src/notes/domain/NoteContext';
import { useFindAllNotesForPermit } from '@src/notes/hooks/useFindAllNotesForPermit';
import { BackToOrderDetails } from '@src/orders/components/BackToOrderDetails';
import { BackToReview } from '@src/orders/components/BackToReviewDetails';
import { NoteTable } from '@src/orders/components/note/NoteTable';
import type { PermitSummary } from '@src/orders/domain/PermitSummary';
import { useTranslation } from 'react-i18next';

type Props = {
  permitSummary: PermitSummary;
  mode: 'permitNotes' | 'reviewPermitNotes';
};

export const PermitNotes = (props: Props) => {
  const { t } = useTranslation();

  const {
    notes,
    isLoading,
    refetch: refetchNotes,
  } = useFindAllNotesForPermit(props.permitSummary.id);

  if (isLoading) {
    return <LoadingPage />;
  }

  const hasNotes = notes.length > 0;

  return (
    <PageLayout
      title={t('permitNotes.title', {
        jurisdiction: props.permitSummary.jurisdiction,
        permitType: props.permitSummary.type,
      })}
      style={{ margin: '24px', flex: 1 }}
    >
      <Stack width="fit-content" alignSelf="flex-start">
        {props.mode === 'reviewPermitNotes' ? (
          <BackToReview />
        ) : (
          <BackToOrderDetails />
        )}
      </Stack>
      <Divider />
      <Stack gap={theme.spacing['6']}>
        <AddNote
          defaultNoteContext={
            props.mode === 'reviewPermitNotes'
              ? [NoteContext.finance]
              : undefined
          }
          isInitiallyAddingNote={!hasNotes}
          parentId={props.permitSummary.id}
          parentType="PERMIT_APPLICATION"
          onAddNote={refetchNotes}
        />
        {hasNotes && <NoteTable notes={notes} />}
      </Stack>
    </PageLayout>
  );
};
